<template>
	<section class="apps-wrapper">
		<div class="container">
			<div class="header">
				<h1 class="title">اپلیکیشن‌ها</h1>
				<span class="hr"></span>
<!--				<hr>-->

			</div>

			<div class="apps-grid">
				<AppCard
					v-for="app in apps"
					:key="app.id"
					:app="app"
				/>
			</div>
		</div>
	</section>
</template>

<script>
import AppCard from '@/components/AppCard.vue'

export default {
	name: 'AppsPage',
	components: { AppCard },
	data() {
		return {
			apps: [
				{
					id: 'panguin',
					name: 'Panguin',
					subtitle: 'English Learn',
					image: 'panguin-logo.png',
					active: true
				},
				{
					id: 'shrapp',
					name: 'SHR Coming Soon',
					subtitle: '',
					image: 'panguin-logo.png',
					active: false
				}
			]
		}
	}
}
</script>

<style lang="scss" scoped>
.apps-wrapper {
	background-color: #1e1e2f;
	min-height: 100vh;
	padding: 3rem 1.5rem;

	.container {
		max-width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;

	}

	.header {
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 2rem;

		.title {
			font-size: 1.8rem;
			color: #fff;
			padding-bottom: 0.5rem;
		}

		.hr {
			flex-grow: 1;
			margin-right: 1rem;
			border: none;
			height: 1px;
			background-color: #858181;
		}
	}

	.apps-grid {
		display: grid;
		grid-template-columns: 1fr;
		gap: 1.5rem;
		width: 100%;
		justify-items: center;

		@media (min-width: 640px) {
			grid-template-columns: repeat(2, 1fr);
		}

		@media (min-width: 1024px) {
			grid-template-columns: repeat(3, 1fr);
		}
	}
}
</style>